import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThresholdPerformanceService {
  getThresholdPerformanceChartData() {
    const thresholdChartData = [];
    for (let threshold = 0; threshold <= 1.05; threshold += 0.05) {
      // As threshold increases:
      // - Adoption rate decreases (fewer SKU-locations meet the higher threshold)
      // - RmseChange increases (only high-confidence predictions are used)
      // - Avg performance score increases (only better predictions meet the threshold)

      const normalizedThreshold = threshold;

      // Adoption rate: Starts high (~95%), decreases as threshold increases
      // Uses exponential decay to simulate real-world behavior
      const adoptionRate = 95 * Math.exp(-normalizedThreshold * 2.5) + 5;

      // RmseChange: Starts moderate (~75%), increases as threshold increases
      // Asymptotically approaches ~95%
      const RmseChange = 75 + 20 * (1 - Math.exp(-normalizedThreshold * 3));

      // Average performance score: Starts at threshold value, increases slightly
      // SKUs that meet higher thresholds tend to have even higher scores on average
      const avgPerformanceScore = threshold * 100 + 10 * (1 - Math.exp(-normalizedThreshold * 2));

      thresholdChartData.push({
        threshold: parseFloat(threshold.toFixed(2)),
        adoptionRate: parseFloat(adoptionRate.toFixed(1)),
        RmseChange: parseFloat(RmseChange.toFixed(1)),
        avgPerformanceScore: parseFloat(Math.min(avgPerformanceScore, 95).toFixed(1))
      });
    }
    return thresholdChartData;
  }
}
